import { render, staticRenderFns } from "./CloneInventory.vue?vue&type=template&id=590c2469&scoped=true"
import script from "./CloneInventory.vue?vue&type=script&lang=js"
export * from "./CloneInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c2469",
  null
  
)

export default component.exports